<ion-header translucent>
  <ion-toolbar>
    <ion-title class="fs-4 ion-no-padding title-class ion-padding-start">{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" class="primary-icon-color"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      mode="ios"
      placeholder="Search"
      (ionInput)="onSearch($event)"
      (ionClear)="onSearch($event)"
    ></ion-searchbar>
  </ion-toolbar>
  
</ion-header>

<ion-content>
  <ion-list class="options-list">
    <ion-item button [detail]="false" *ngFor="let option of filteredOptions" (click)="selectOption(option)">
      <ion-label class="fs-3">{{ option }}</ion-label>
    </ion-item>
  </ion-list>
</ion-content>


